import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const updatePlayField = createJpdExperience(
	new UFOExperience('jpd.play-sidepanel.field-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
